/*  Accordion toggle functionality
 *
 * @file combined
 */

// Classes for the accordion
const accordionClasses = {
    containerClass: '.rs-accordion', // accordion parent class.
    rowClass: '.rs-accordion__row', // accordion container class.
    toggleClass: 'rs-accordion__heading', // accordion toggle class.
    singleOpenClass: 'rs-accordion__accordions--single-open', // accordion class for single-open
    activeClass: 'is_active', // accordion active class
};

/*
 * Main Function watches for clicks
 */
export default function accordionToggle() {
    // Listen for clicks
    document.addEventListener(
        'click',
        event => {
            // If the clicked element doesn't have the right selector, bail.
            if (
                !event.target.classList.contains(accordionClasses.toggleClass)
            ) {
                return;
            }
            // Don't follow the link.
            event.preventDefault();
            // Handle the click.
            handleClick(event.target);
        },
        false
    );
}

/*
 * Handles adding toggle classes when toggle element is clicked
 */
function handleClick(clickedElement) {
    // check if is_ative class exist or not.
    const isActive = clickedElement.parentElement.classList.contains(
        'is_active'
    );

    // add overflow auto or hidden to rs-accordion__body
    if (isActive) {
        clickedElement.nextElementSibling.style.overflowY = 'hidden';
    } else {
        setTimeout(() => {
            clickedElement.nextElementSibling.style.overflowY = 'auto';
        }, 300);
    }

    // get parent container.
    const clickedRow = clickedElement.closest(accordionClasses.rowClass);

    // Toggle active class.
    clickedRow.classList.toggle(accordionClasses.activeClass);
    // Get parent container.
    const parentContainer = clickedRow.closest(accordionClasses.containerClass);
    // If Parent Container has the 'single-only' class, close sibling rows.
    if (parentContainer.classList.contains(accordionClasses.singleOpenClass)) {
        // get accordions
        const siblingRows = parentContainer.children;
        // Loop through the row siblings
        for (const sibling of siblingRows) {
            if (
                // check to make sure the node is an element and isn't the currently clicked element
                sibling.nodeType === 1 &&
                sibling !== clickedRow
            ) {
                // remove the active from the sibling element
                sibling.classList.remove(accordionClasses.activeClass);
            }
        }
    }
}
